import { gql } from "@apollo/client";

export default gql`
  mutation createCompany(
    $name: String
    $nameAr: String
    $logo: String
    $tel1: String
    $tel2: String
    $fax: String
    $mob: String
    $email: String
    $website: String
    $address: String
    $poBox: String
    $packId: Int
  ) {
    createCompany(
      name: $name
      nameAr: $nameAr
      logo: $logo
      tel1: $tel1
      tel2: $tel2
      fax: $fax
      mob: $mob
      email: $email
      website: $website
      address: $address
      poBox: $poBox
      packId: $packId
    ) {
      ok
      message
      data
      error
    }
  }
`;
